import type {
  ArtifactItem,
  ConversationMessageDTO,
} from '@eriko/shared-types';
import type { ChatMessage } from '../../stores/chatStore';

export function mapConversationMessage(msg: ConversationMessageDTO, index: number) {
  const meta = (msg.metadata as Record<string, unknown> | null) ?? null;
  const forkNote =
    msg.senderType === 'AI' && meta?.forkNote
      ? {
          toConversationId: String(meta.toConversationId),
          toTitle: String(meta.toTitle),
          reason: msg.content,
        }
      : undefined;
  return {
    id: msg.id ?? `loaded-${index}`,
    role: (msg.senderType === 'AI' ? 'assistant' : 'user') as 'user' | 'assistant',
    content: msg.content,
    timestamp: msg.createdAt
      ? (() => {
          const d = new Date(msg.createdAt);
          return `${d.getHours().toString().padStart(2, '0')}:${d
            .getMinutes()
            .toString()
            .padStart(2, '0')}`;
        })()
      : '',
    senderType: msg.senderType,
    senderId: msg.senderId,
    ...(forkNote ? { forkNote } : {}),
    metadata: (msg.metadata ?? null) as ChatMessage['metadata'],
  };
}

export function extractArtifacts(messages: ConversationMessageDTO[]): ArtifactItem[] {
  const artifacts: ArtifactItem[] = [];
  for (const msg of messages) {
    if (msg.senderType === 'AI' && msg.metadata?.artifacts) {
      const arr = msg.metadata.artifacts as Array<{
        type: 'artifact';
        messageIndex: number;
        data: Record<string, unknown>;
      }>;
      for (const entry of arr) {
        artifacts.push({
          messageIndex: entry.messageIndex,
          type: (entry.data?.type as string) ?? 'unknown',
          data: entry.data,
        });
      }
    }
  }
  return artifacts;
}
